/* eslint-disable max-len */
import React from 'react';
function Required() {
    return (React.createElement("g", null,
        React.createElement("path", { d: "M12.9672 3.99989H11.0381V10.4576L4.96442 7.22585L3.9999 8.7654L10.0789 12L4.00037 15.2344L4.96488 16.774L11.0381 13.5424V19.9999H12.9672V13.5368L19.0349 16.7654L19.9993 15.2258L13.9368 12L19.9998 8.77394L19.0354 7.23437L12.9672 10.4632V3.99989Z" })));
}
export default Required;
